module.exports = __webpack_public_path__ + "static/media/apropos_bg.365a7088.png";